import { render } from "./DictionariesView.vue?vue&type=template&id=7afae049&ts=true"
import script from "./DictionariesView.vue?vue&type=script&lang=ts"
export * from "./DictionariesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__